<template>
  <div
    :class="{'personal-objective': true, pointer: canEdit}"
    @click="clickHandler"
  >
    <div v-if="isPerformanceLeader">
      <div
        v-for="item in organizationalSkillsPerspective"
        :key="item"
        class="item"
      >
        <div class="title">
          {{ $t(`okr.personalObjective.${item}`) }}
          <span class="after">{{ $t('shared.weight') }} : 10%</span>
        </div>
        <div
          class="value"
          v-html="replaceStr2Html(organizationalSkills[item]||'')"
        />
      </div>
    </div>
    <div v-else>
      <div
        v-for="item in personalDevelopmentPerspective"
        :key="item"
        class="item"
      >
        <div class="title">
          {{ $t(`okr.personalObjective.${item}`) }}
          <span class="after">{{ $t('shared.weight') }} : 10%</span>
        </div>
        <div
          class="value"
          v-html="replaceStr2Html(personalDevelopment[item]||'')"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { useStore } from 'vuex'
import {
  organizationalSkillsPerspective,
  personalDevelopmentPerspective
} from '@/constants/perspective'
import { replaceStr2Html } from '@/utils/line-break'
export default {
  props: {
    organizationalSkills: {
      type: Object,
      default: () => {}
    },
    personalDevelopment: {
      type: Object,
      default: () => {}
    },
    canEdit: {
      type: Boolean,
      required: true
    },
    isPerformanceLeader: {
      type: Boolean,
      default: false
    }
  },
  emits: ['create-objective'],
  setup (props, { emit }) {
    const { state } = useStore()
    const clickHandler = () => {
      if (props.canEdit) {
        emit('create-objective')
      }
    }
    return {
      organizationalSkillsPerspective,
      personalDevelopmentPerspective,
      user: state.user,
      clickHandler,
      replaceStr2Html
    }
  }
}
</script>
<style lang="less" scoped>
.item:not(:last-child) {
  margin-bottom: 24px;
}

.title {
  font-weight: bolder;
}
.value {
  padding-top: 12px;
}
.personal-objective {
  padding: 16px 26px 16px 52px;
}
.pointer {
  cursor: pointer;
}

.after {
  margin-left: 12px;
  font-weight: 400;
}
</style>
